import { render, staticRenderFns } from "./Invoices.vue?vue&type=template&id=351f0dca&scoped=true&"
import script from "./Invoices.vue?vue&type=script&lang=js&"
export * from "./Invoices.vue?vue&type=script&lang=js&"
import style0 from "./Invoices.vue?vue&type=style&index=0&id=351f0dca&prod&scoped=true&lang=css&"
import style1 from "./Invoices.vue?vue&type=style&index=1&id=351f0dca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351f0dca",
  null
  
)

export default component.exports